import { THEME_QUERY_KEY, UDV_CHROME_THEMES } from './constants'

/**
 * @param {string|null|undefined} raw
 * @returns {'dark'|'brand'|'light'|null}
 */
export function parseThemeQueryParam(raw) {
  if (raw == null || raw === '') return null
  const v = String(raw).trim().toLowerCase()
  if (
    v === UDV_CHROME_THEMES.DARK ||
    v === UDV_CHROME_THEMES.BRAND ||
    v === UDV_CHROME_THEMES.LIGHT
  ) {
    return v
  }
  return null
}

/**
 * @param {URLSearchParams|null|undefined} params
 * @returns {'dark'|'brand'|'light'|null}
 */
export function parseThemeFromSearchParams(params) {
  if (!params || typeof params.get !== 'function') return null
  return parseThemeQueryParam(params.get(THEME_QUERY_KEY))
}
